<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col lg:flex-row justify-center items-center col-span-full"
    >
      <section
        class="flex justify-center xl:justify-end w-full lg:w-1/2 bg-gray-500 text-white py-12"
      >
        <section class="max-w-md xl:max-w-133.25 px-20-px xl:pr-10 xl:pl-0">
          <p
            class="px-20-px lg:px-0 text-4xl"
            v-text="'Agregar título de banner segun la Temática'"
          />
          <ul class="flex flex-col gap-y-8 text-lg pt-8 list-disc pl-4 md:pl-0">
            <li
              class="max-w-66.75 md:max-w-full"
              v-text="
                'Lorem Ipsum is simply dummy textof the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'
              "
            />
            <li
              class="max-w-66.75 md:max-w-full"
              v-text="
                'Lorem Ipsum is simply dummy textof the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'
              "
            />
            <li
              class="max-w-66.75 md:max-w-full"
              v-text="
                'Lorem Ipsum is simply dummy textof the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'
              "
            />
          </ul>
          <section class="pt-8">
            <main-button />
          </section>
        </section>
      </section>
      <section class="h-115.5 lg:h-full w-full lg:w-1/2 bg-gray-400"/>
    </section>
  </section>
</template>
<script>
export default {
  components: {
    MainButton: () => import("../components/MainButton.vue"),
  },
  props:{
    withBorder: {
      default: true
    }
  }
};
</script>
